<template lang="html">
  <main-sidebar :name="name" :title="$t('add_new_bank_statement')">
    <div class="p-4">
      <vs-row class="mb-2">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
          <label>{{ $t('client') }}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
          <v-select v-model="client" :options="clients" class="w-full"  :reduce="client => client.ClientId" label="ClientName"  :disabled="Object.entries(data).length > 0 ? true:false" @input="getAccounts" />
        </vs-col>
      </vs-row>
      <vs-row class="mb-2">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
          <label>{{ $t('period') }}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-xs="12" vs-sm="6" vs-lg="6" class="pr-1">
          <v-select v-model="month" :placeholder="$t('month')" :options="months" class="w-full" :reduce="opt => opt.id" label="text" />
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-xs="12" vs-sm="6" vs-lg="6" class="pl-1">
          <vs-input v-model="year" class="w-full" v-validate="'required|min:4|max:4'" :placeholder="$t('year')" name="year" autocomplete="off" />
        </vs-col>
        <span class="text-danger text-sm" v-show="errors.has('year')">
          {{ errors.first('year') }}
        </span>
      </vs-row>
      <vs-row class="mb-2">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
          <label>{{ $t('bank') }}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
          <v-select v-model="account" :options="accounts" class="w-full" label="account" />
        </vs-col>
      </vs-row>
      <vs-row class="mb-2">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
          <label>{{ $t('currency') }}</label>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
          <vs-input :value="currency" class="w-full" :placeholder="$t('currency')" disabled />
        </vs-col>
      </vs-row>
      <vs-row>
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="12">
          <upload-file v-model="files" list multiple btnType="filled" btnColor="#7367F0" class="w-ful" :btnText="$t('upload_pdf')" accept="application/pdf" />
        </vs-col>
      </vs-row>
    </div>
    <div class="mx-4" slot="footer">
      <vs-button color="primary" type="filled" class="mr-6" @click="handleSubmit" :disabled="disabledSubmit">
         {{ $t('submit') }}
      </vs-button>
      <vs-button color="primary" type="border"@click="close">
        {{ $t('cancel') }}
      </vs-button>
    </div>
  </main-sidebar>
</template>
<script>
import loading from '@/mixins/Loading.js'
import MainSidebar from '@/views/components/MainSidebar.vue'
import statement from '@/http/requests/statement'
import UploadFile from '@/views/components/UploadFile.vue'
import validate from '@/mixins/Validate.js'
import vSelect from 'vue-select'

export default {
  components: {
    MainSidebar,
    UploadFile,
    'v-select': vSelect,
  },
  computed: {
    isLoading() {
      return this.loading.accounts || this.loading.submit
    },
    isSidebarActive() {
      return this.$store.state.sidebar === this.name
    },
    currency(){
      if( this.account !== null ){
        return this.account.currency
      }
      return ''
    },
    disabledSubmit() {
      return (
        this.month === '' ||
        this.year === '' ||
        this.account === null ||
        (this.files.length === 0 &&
          Object.entries(this.data).length === 0) ||
        this.errors.any()
      )
    },
  },
  data: () => ({
    accounts: [],
    name: 'add-bank-statement',
    client: '',
    month: '',
    year: '',
    account: null,
    files: [],
    months: [],
    loading: {
      accounts: false,
      submit: false,
    },
  }),
  methods: {
    close() {
      this.$store.dispatch('toggleSidebar', '')
    },
    getAccounts() {
      this.account = null
      this.loading.accounts = true
      statement
        .getAccountList({ client: this.client })
        .then((res) => {
          this.loading.accounts = false
          this.accounts = res.data.items
          if (this.accounts.length == 0) {
            this.accounts = [
              {
                account_id: null,
                account: 'No Disponible',
                currency: 'No Disponible',
              },
            ]
            this.account = this.accounts[0]
          }else{
            if(Object.entries(this.data).length > 0){
              this.account = this.accounts.find((el) => el.account_id == this.data.account_id)
            }
          }
          
        })
        .catch((err) => {
          this.loading.accounts = false
        })
    },
    getMonths() {
      this.months = [
        {
          id: '01',
          text: '01',
        },
        {
          id: '02',
          text: '02',
        },
        {
          id: '03',
          text: '03',
        },
        {
          id: '04',
          text: '04',
        },
        {
          id: '05',
          text: '05',
        },
        {
          id: '06',
          text: '06',
        },
        {
          id: '07',
          text: '07',
        },
        {
          id: '08',
          text: '08',
        },
        {
          id: '09',
          text: '09',
        },
        {
          id: '10',
          text: '10',
        },
        {
          id: '11',
          text: '11',
        },
        {
          id: '12',
          text: '12',
        },
      ]
    },
    handleSubmit() {
      this.loading.submit = true
      let data = new FormData()
      data.append('month', this.month)
      data.append('year', this.year)
      data.append('account', this.account.account_id)
      this.files.forEach(function (file, i) {
        data.append('files[]', file)
      })
      if (Object.entries(this.data).length === 0) {
        this.$store
          .dispatch('statement/addStatement', data)
          .then((res) => {
            this.$vs.notify({
              color: 'success',
              title: 'Success',
              text: 'Item Added',
            })
            this.close()
            this.loading.submit = false
          })
          .catch((err) => {
            this.loading.submit = false
            this.displayErrors(err)
          })
      } else {
        data.append('statement_id', this.data.id)
        this.$store
          .dispatch('statement/updateStatement', data)
          .then((res) => {
            this.$vs.notify({
              color: 'success',
              title: 'Success',
              text: 'Item Updated',
            })
            this.close()
            this.loading.submit = false
          })
          .catch((err) => {
            this.loading.submit = false
            this.displayErrors(err)
          })
      }
    },
    init() {
      this.getMonths()
      this.initForm()
      this.$validator.reset()
    },
    initForm() {
      if (Object.entries(this.data).length === 0) {
        this.month = ''
        this.year = ''
        this.account = null
        this.files = []
        this.client = null
      }else{
      //const { client_id, month, year, account_id, currency, id } = this.data
      this.client = this.data.client_id
      this.month = this.data.month
      this.year = this.data.year
      this.files = []
      }
     
      this.getAccounts()
  
    }
  },
  mixins: [loading, validate],
  props: {
    clients: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    isLoading(val) {
      if (val) {
        this.openLoading(`loading-${this.name}-sidebar`)
        return
      }
      this.closeLoading(`loading-${this.name}-sidebar`)
      return
    },
    isSidebarActive(val) {
      if (val) {
        this.init()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>
